import type { ActionBehaviours } from '../tools/do-action.tool';
import { runOnScreen } from './fast-lane';
import { confirmOnScreen, OnScreenConfirmDeps } from './other-confirm';

const FAST = ['rename-workspace', 'set-person-name', 'set-workspace-arrival-notices', 'expand-workspace-row', 'search-workspaces'];

const CONFIRM = [
  'set-seat-cap', 'add-person', 'change-person-role', 'set-person-password', 'set-person-sign-in-email',
  'remove-person', 'transfer-person', 'erase-person', 'reinstate-person', 'restore-workspace',
];

/** What Claude does in a workspace's row. The row and its people are found by `WorkspacesTabComponent`, which offers these. */
export function makeWorkspaceFormBehaviours(deps: OnScreenConfirmDeps): ActionBehaviours {
  const confirm = confirmOnScreen(deps);
  return {
    ...Object.fromEntries(FAST.map((id) => [id, { fast: runOnScreen }])),
    ...Object.fromEntries(CONFIRM.map((id) => [id, { confirm }])),
  };
}
